var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.title ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Title')
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "float-right px-4 hidden-xs-only"
  }, [_c('v-img', {
    attrs: {
      "width": _vm.$size() * 4,
      "height": _vm.$size(),
      "contain": "",
      "src": _vm.icon
    }
  })], 1), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.title.m_DisplayName, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.title.m_DisplayName))])]), _c('div', {
    staticClass: "px-4 hidden-sm-and-up"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.icon
    }
  })], 1), _c('div', {
    staticClass: "pb-4"
  }), _c('p', {
    staticClass: "px-4",
    class: {
      small: _vm.$vuetify.breakpoint.xsOnly
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title.m_Descript.replace(/\n/g, '<br>'))
    }
  }), _c('v-list-item', {
    attrs: {
      "to": "/scenariolibrary/".concat(5000 + parseInt(_vm.id))
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Scenarios')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/questlibrary/".concat(5000 + parseInt(_vm.id))
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Quest Library Categories.5')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), _c('v-list-item', {
    attrs: {
      "to": "/questlibrary/".concat(6000 + parseInt(_vm.id))
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Quest Library Categories.6')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), _c('v-divider'), _c('Ad', {
    key: "title-ad-".concat(_vm.id)
  }), _vm.id == 22 ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Names')))]), _c('Scroller', {
    attrs: {
      "icon": _vm.$size(64)
    }
  }, [_vm._l(_vm.$store.state.$db.OriginalCharaLibraryListArray, function (character) {
    return character.namedType ? _c('div', {
      key: "title-original-character-".concat(character.m_ID),
      staticClass: "ml-4",
      style: {
        width: _vm.$size(64) + 'px'
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/named/".concat(character.namedType)
      }
    }, [_c('CharaIcon', {
      attrs: {
        "original": "",
        "id": character.m_ID,
        "size": _vm.$size(64)
      }
    }), _c('div', {
      staticClass: "caption text-center two-lines"
    }, [_vm._v(_vm._s(_vm.$name(character.m_Title)))])], 1)], 1) : _vm._e();
  }), _c('div', {
    staticClass: "pl-4"
  })], 2), _c('p', {
    staticClass: "px-4 subtitle-1"
  }, [_vm._v(_vm._s(_vm.$t('Non-Player Characters')))]), _c('Scroller', {
    attrs: {
      "icon": _vm.$size(64)
    }
  }, [_vm._l(_vm.$store.state.$db.OriginalCharaLibraryListArray, function (character) {
    return !character.namedType && character.m_CondAdvID == -1 ? _c('div', {
      key: "title-original-character-".concat(character.m_ID),
      staticClass: "ml-4",
      style: {
        width: _vm.$size(64) + 'px'
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/originalcharacter/".concat(character.m_ID)
      }
    }, [_c('CharaIcon', {
      attrs: {
        "original": "",
        "id": character.m_ID,
        "size": _vm.$size(64)
      }
    }), _c('div', {
      staticClass: "caption text-center two-lines"
    }, [_vm._v(_vm._s(_vm.$name(character.m_Title)))])], 1)], 1) : _vm._e();
  }), _c('div', {
    staticClass: "pl-4"
  })], 2), _c('p', {
    staticClass: "px-4 subtitle-1"
  }, [_vm._v(_vm._s(_vm.$t('Event Characters')))]), _c('Scroller', {
    attrs: {
      "icon": _vm.$size(64)
    }
  }, [_vm._l(_vm.$store.state.$db.OriginalCharaLibraryListArray, function (character) {
    return !character.namedType && character.m_CondAdvID != -1 ? _c('div', {
      key: "title-original-character-".concat(character.m_ID),
      staticClass: "ml-4",
      style: {
        width: _vm.$size(64) + 'px'
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/originalcharacter/".concat(character.m_ID)
      }
    }, [_c('CharaIcon', {
      attrs: {
        "original": "",
        "id": character.m_ID,
        "size": _vm.$size(64)
      }
    }), _c('div', {
      staticClass: "caption text-center two-lines"
    }, [_vm._v(_vm._s(_vm.$name(character.m_Title)))])], 1)], 1) : _vm._e();
  }), _c('div', {
    staticClass: "pl-4"
  })], 2)] : [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Names')))]), _c('Scroller', {
    attrs: {
      "icon": _vm.$size(64)
    }
  }, [_vm._l(_vm.names, function (named) {
    return _c('div', {
      key: "title-names-".concat(named.m_NamedType),
      staticClass: "ml-4",
      style: {
        width: _vm.$size(64) + 'px'
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/named/".concat(named.m_NamedType)
      }
    }, [_c('CharaIcon', {
      attrs: {
        "named": "",
        "id": named.m_NamedType,
        "size": _vm.$size(64)
      }
    }), _c('div', {
      staticClass: "caption text-center two-lines"
    }, [_vm._v(_vm._s(_vm.$name(named.fullName)))])], 1)], 1);
  }), _c('div', {
    staticClass: "pl-4"
  })], 2)], _c('v-divider'), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-list-item', {
    attrs: {
      "to": "/characters?title=".concat(_vm.id)
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Number of Characters')))]), _c('v-list-item-title', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.count(0)))])], 1)], 1)], 1), _c('v-col', [_c('v-list-item', {
    attrs: {
      "to": "/characters?title=".concat(_vm.id, "&rare=4")
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Rares.4')))]), _c('v-list-item-title', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.count(4)))])], 1)], 1)], 1), _c('v-col', [_c('v-list-item', {
    attrs: {
      "to": "/characters?title=".concat(_vm.id, "&rare=3")
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Rares.3')))]), _c('v-list-item-title', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.count(3)))])], 1)], 1)], 1), _c('v-col', [_c('v-list-item', {
    attrs: {
      "to": "/characters?title=".concat(_vm.id, "&rare=2")
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Rares.2')))]), _c('v-list-item-title', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.count(2)))])], 1)], 1)], 1)], 1), _c('Achievements', {
    attrs: {
      "id": _vm.id
    }
  }), _vm._l(_vm.orbs, function (orb) {
    return [_c('v-divider'), _c('Orb', {
      key: "title-orb-".concat(orb.m_ID),
      attrs: {
        "id": orb.m_ID
      }
    })];
  }), _vm._l(_vm.townObjects, function (item) {
    return [_c('v-divider'), _c('TownObject', {
      key: "title-townobject-".concat(item.m_ID),
      attrs: {
        "id": item.m_ID
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }